import "./index.css";
import "@dpdgroupuk/ai-app/styles/index.css";

import { each } from "lodash";
import { Route } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { SnackbarProvider } from "notistack";
import moment from "moment-timezone";
import { Provider as OracleProvider } from "@dpdgroupuk/ai-app";

import pkg from "../package.json";

import { PAGES, PAGE_TITLE_ROUTE_MAP } from "./consts/pages";
import theme from "./theme";

import { apis } from "./services/api";
import store from "./reducers";

import { Error } from "./components/Error";
import { Notifier } from "./components/Notifier";
import { UserPageHOC } from "./pages/UserPageHOC";

import reportWebVitals from "./reportWebVitals";

const { REACT_APP_MAIN_PROJECT_URL, REACT_APP_MAIN_PROJECT_API } = process.env;

moment.tz.setDefault("UTC");

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: "new-route-matrix@" + pkg.version,
  environment: process.env.REACT_APP_SENTRY_ENV,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.2,
  normalizeDepth: 5,
  beforeBreadcrumb: (breadcrumb, hint) => {
    let sentryId;
    each(hint?.event?.path || [], (path) => {
      if (!!sentryId) return;
      sentryId = path.attributes?.["sentryId"]?.value;
    });
    return {
      ...breadcrumb,
      message: sentryId
        ? `${sentryId} => ${breadcrumb.message}`
        : breadcrumb.message,
    };
  },
});

const root = createRoot(document.getElementById("root"));
root.render(
  // DO NOT wrap in <React.StrictMode> as it will break mapbox in react 18
  <Sentry.ErrorBoundary fallback={Error} showDialog>
    <Provider store={store}>
      <SnackbarProvider
        maxSnack={7}
        classes={{ containerAnchorOriginBottomLeft: "SnackbarItem-ZIndex" }}
      >
        <OracleProvider
          axiosInstance={apis.auth}
          mainProjectUrl={REACT_APP_MAIN_PROJECT_URL}
          mainProjectApiUrl={REACT_APP_MAIN_PROJECT_API}
          pageTitleMapper={PAGE_TITLE_ROUTE_MAP}
          themeConfig={theme}
        >
          {PAGES.map(({ path, element: Page, requiredRole }) => (
            <Route
              path={path}
              element={
                <UserPageHOC PageComponent={Page} requiredRole={requiredRole} />
              }
            />
          ))}
        </OracleProvider>
        <Notifier />
      </SnackbarProvider>
    </Provider>
  </Sentry.ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
